import React, { FC } from 'react';
import { View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { easeGradient } from 'react-native-easing-gradient';
import { scale } from '@components/frame';
import { ShowFullNcFileButton } from './ShowFullNcFileButton';
import { OVERLAY_HEIGHT, BUTTON_BOTTOM_OFFSET, UPPER_GRADIENT_RATIO, LOWER_GRADIENT_RATIO } from './constants';
import { ShowFullNcFileOverlayProps } from './types';

const ShowFullNcFileOverlay: FC<ShowFullNcFileOverlayProps> = ({ C, ncFileId, ncFileName, baseColor, onPress }) => {
  const { colors: gradientColors, locations: gradientLocations } = easeGradient({
    colorStops: {
      0: { color: `rgba(${baseColor}, 0)` },
      1: { color: `rgba(${baseColor}, 0.9)` },
    },
  });

  const { colors: gradientColors2, locations: gradientLocations2 } = easeGradient({
    colorStops: {
      0: { color: `rgba(${baseColor}, 0.9)` },
      1: { color: `rgba(${baseColor}, 1)` },
    },
  });

  return (
    <View
      style={{
        width: '100%',
        position: 'absolute',
        height: scale(OVERLAY_HEIGHT),
        bottom: 0,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 100,
      }}
    >
      <LinearGradient
        locations={gradientLocations}
        colors={gradientColors}
        style={{ position: 'absolute', zIndex: 10, height: scale(OVERLAY_HEIGHT) * UPPER_GRADIENT_RATIO, width: '100%' }}
      >
        <View />
      </LinearGradient>
      <LinearGradient
        locations={gradientLocations2}
        colors={gradientColors2}
        style={{ position: 'absolute', zIndex: 10, height: scale(OVERLAY_HEIGHT) * LOWER_GRADIENT_RATIO, bottom: 0, width: '100%' }}
      >
        <View />
      </LinearGradient>
      <View style={{ position: 'absolute', zIndex: 100, bottom: scale(BUTTON_BOTTOM_OFFSET) }}>
        <ShowFullNcFileButton C={C} ncFileId={ncFileId} ncFileName={ncFileName} onPress={onPress} />
      </View>
    </View>
  );
};

export { ShowFullNcFileOverlay };
